import { nextTick } from 'vue';
import { vueCreateAppInit } from '@/utils/js/initVariable';
import { message } from '@/utils/js/initVariable';
import CustomLocaleControl from '@/views/Home/component/ManagePanel/components/WorkSpace/components/WorkSpaceData/components/CustomLocaleControl';

/**
 * 地图绘制事件 & CustomLocaleControl 挂载
 * @param {Object} map - Leaflet 地图实例（raw）
 * @param {Object} layerGroup - 图层组
 * @param {Object} options - 可选配置
 * @param {Function} options.onLayerDelete - 图层删除回调
 * @param {Function} options.onFileUpload - 文件上传事件回调（layerType == 'fileUpload' 时触发）
 * @param {Array} options.workSpaceDataList - 数据列表（传入 CustomLocaleControl）
 * @param {Object} options.workSpace - 工作空间对象（传入 CustomLocaleControl）
 */
export function useMapDrawControl(map, layerGroup, options = {}) {

  /**
   * 每个图层独立挂载一个 CustomLocaleControl
   * 点击图层 toggle 显隐
   */
  const customLocaleControlInit = (layer, target) => {
    const bounds = layer.getBounds && layer.getBounds();
    if (!bounds || !bounds.isValid()) return;

    const layerClick = () => {
      const icon = controlMarker && controlMarker._icon;
      if (!icon) return;
      icon.style.display = icon.style.display === 'none' ? 'unset' : 'none';
    }

    const app = vueCreateAppInit(CustomLocaleControl, {
      target,
      layer,
      layerGroup,
      map,
      onLayerDelete: () => {
        layerGroup.removeLayer(layer);
        options.onLayerDelete && options.onLayerDelete(layer);
      },
      layerClick,
      ...(options.workSpace ? { workSpace: options.workSpace } : {}),
      ...(options.workSpaceDataList ? { workSpaceDataList: options.workSpaceDataList } : {}),
    });

    let isMounted = false;
    const controlMarker = L.marker(bounds.getNorthEast(), {
      icon: L.divIcon({
        iconAnchor: [-5, 0],
      }),
    }).on({
      remove: () => {
        try { if (isMounted) { app.unmount(); isMounted = false; } } catch(e) {}
      }
    }).addTo(layerGroup);

    nextTick(() => {
      const icon = controlMarker._icon;
      if (icon) {
        icon.style.display = 'none';
        app.mount(icon);
        isMounted = true;
      }
    })

    layer.on({
      remove: () => {
        layerGroup.removeLayer(controlMarker);
      }
    })
  }

  /**
   * DRAWSTOP 监听 —— 新增绘制完成后挂载 CustomLocaleControl
   */
  const bindDrawStop = () => {
    map.on(L.Draw.Event.DRAWSTOP, event => {
      if (!event.layer) return;
      // 文件上传类型（marker）走单独分支
      if (event.layerType == 'fileUpload') {
        options.onFileUpload && options.onFileUpload(event);
        return;
      }
      const layer = event.layer;
      // 将事件中的 layerType 写入 layer.options，供 CustomLocaleControl 读取
      if (event.layerType) {
        layer.options['layerType'] = event.layerType;
      }
      const bounds = layer.getBounds && layer.getBounds();
      if (!bounds || !bounds.isValid()) {
        message('无效区域', 2);
        return;
      }
      customLocaleControlInit(layer, {});
      layerGroup.addLayer(layer);
    });
  }

  const unbindDrawStop = () => {
    map.off(L.Draw.Event.DRAWSTOP);
  }

  return { customLocaleControlInit, bindDrawStop, unbindDrawStop };
}
